window.$ = window.jQuery = require('jquery');
require('./bootstrap');

(function($) {

	var wWidth = $(window).outerWidth();
	if(wWidth > 700) {
		wWidth = 700;
	} else {
		wWidth = 0.8 * wWidth;
	}

//***********************
// ****** CUSTOMER FUNCTIONS

window.usernameLookup = function(addy) {
	//console.log("looking for "+addy)
	$.ajaxSetup({
	    headers: {
	        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	    }
	});
    $.ajax({
        url: '/user/lookup',
        type: 'post',
        data: {address:addy},
        dataType: 'JSON',
        success: function(data) {
	        console.log(data);
            if(data.success) {
	            $(".results .content").html("Your username is <strong>"+data.username+"</strong>");
	            $(".results .footnote").show();
            } else {
	            $(".results .content").html("Sorry, we were not able to find a username.<br>If the address contains commonly abbreviated items, please try different variations.")
	            $(".results .footnote").hide();
            }
            $(".results").slideDown(300);
        }
    });
}

window.generatePassword = function() {
    var pass = '';
    var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 
            'abcdefghijklmnopqrstuvwxyz0123456789@#$%!';
      
    for (let i = 1; i <= 14; i++) {
        var char = Math.floor(Math.random()
                    * str.length + 1);
          
        pass += str.charAt(char)
    }
      
    $("#password").val(pass);
}

window.updateCustomer = function(action,title,customer) {
		buttons = {
	        "Save": function() {
				var form = document.getElementById("customer_"+action+"_form");
				var data = new FormData(form);
				var params = {};
				for (var [key, value] of data) {
				    params[key]=value;
				}
				$.ajaxSetup({
				    headers: {
				        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				    }
				});
		        $.ajax({
		            url: '/account/update/'+customer,
		            type: 'post',
		            data: params,
		            dataType: 'JSON',
		            success: function(data) {
			            if(data.success) {
				            $("#messageToast .toast-header .content").html('<i class="fa-solid fa-user-check"></i>&nbsp;<strong class="me-auto">Customer</strong>');
				            $("#messageToast .toast-body").html(data.message);
				            $("#messageToast").toast("show");
				            $("#customer_"+action).html(data.output);
				            $("."+action+"-errors").text('');
							$("#dialog-"+action).dialog('close');
			            } else {
//				            console.log(data.errors);
				            var output='';
				            $("."+action+"-errors").text('');
				            jQuery.each(data.errors, function(i, val) {
							  $("."+action+"-errors").append('<div>'+val[0]+'</div>');
							});
			            }
		            }
		        });
	        },
            "Cancel": function () {
                $(this).dialog('close');
            }
        };
	    showDialogOverlay(action,title,500,buttons);
}

//***********************
// ****** TICKET FUNCTIONS

	window.ticketShowPayment = function(windowheight=500) {
		buttons = {
	            "Cancel": function () {
	                $(this).dialog('close');
	            },
	        };
	    showDialogOverlay('payment',"New Payment",windowheight,buttons);
	}	

	
//***********************
// ******* CART FUNCTIONS	

	window.shopChangeCartQuantity = function(index,qty) {
		$.ajaxSetup({
		    headers: {
		        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		    }
		});
        $.ajax({
            url: '/ajax/shop/cart/update/'+index,
            type: 'POST',
            dataType: 'JSON',
            data: {quantity:qty},
            success: function(data) {
//	            console.log(data);
	            $(".price"+index).text(data.cost);
	            $(".cart-total").text(data.total);
	            if(data.handling>0) {
		            $(".handling-amount").text=data.handling;
		            $(".handling-fee").fadeIn(300);
		        } else {
			        $(".handling-fee").fadeOut(300);
	            }
	            if(data.surcharge>0) {
		            $(".surcharge-amount").text=data.surcharge;
		            $(".surcharge-fee").fadeIn(300);
		        } else {
			        $(".surcharge-fee").fadeOut(300);
	            }
// 	            if(data.tax>0) {
		            $(".tax-amount").text(data.tax);
/*
		            $(".tax-fee").fadeIn(300);
		        } else {
			        $(".tax-fee").fadeOut(300);
	            }
*/
	            $("#messageToast .toast-header .content").html('<i class="fa-solid fa-cart-shopping"></i>&nbsp;<strong class="me-auto">Shopping Cart</strong>');
	            $("#messageToast .toast-body").html("Product quantity updated");
	            $("#messageToast").toast("show");
            }
        });
	}
	window.shopRemoveFromCart = function(msg, title, url, el=null) {
		$.ajaxSetup({
		    headers: {
		        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		    }
		});

	    $("#dialog-confirm").html(msg);
	
		buttons = {
	            "Yes": function () {
	                $(this).dialog('close');
	                $.ajax({
		                url: url,
		                type: 'POST',
		                dataType: 'JSON',
		                success: function(data) {
			                if(parseInt(data.total)==0 || parseInt(data.total)==5) { 
				                window.location = "/shop/cart"; 
				            } else {
					            el.fadeOut(300,function() { el.remove(); });
					            $(".cart-total").text(data.total);
					            if(data.handling>0) {
						            $(".handling-amount").text=data.handling;
						            $(".handling-fee").fadeIn(300);
						        } else {
							        $(".handling-fee").fadeOut(300);
					            }
					            if(data.surcharge>0) {
						            $(".surcharge-amount").text=data.surcharge;
						            $(".surcharge-fee").fadeIn(300);
						        } else {
							        $(".surcharge-fee").fadeOut(300);
					            }
					            if(data.tax>0) {
						            $(".tax-amount").text=data.tax;
						            $(".tax-fee").fadeIn(300);
						        } else {
							        $(".tax-fee").fadeOut(300);
					            }
					            $("#messageToast .toast-header .content").html('<i class="fa-solid fa-cart-shopping"></i>&nbsp;<strong class="me-auto">Shopping Cart</strong>');
					            $("#messageToast .toast-body").html("Product removed");
					            $("#messageToast").toast("show");
					        }
		                }
	                });
	            },
	            "No": function () {
	                $(this).dialog('close');
	            }
	        };
	    showDialogOverlay('confirm',title,400,buttons);
	}
	window.shopAddToCart = function(slug) {
		formid = "#addtocart_form_"+slug;
		params = {product: $(formid+" input[name=product]").val(), qty: $(formid+" .quantity").val(), attributes: $(formid+" .attribute").serialize()};
		$.ajaxSetup({
		    headers: {
		        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		    }
		});
        $.ajax({
            url: "/ajax/shop/cart/add",
            type: 'POST',
            dataType: 'JSON',
            data: params,
            success: function(data) {
	            $("#messageToast .toast-header .content").html('<i class="fa-solid fa-cart-plus"></i>&nbsp;<strong class="me-auto">Shopping Cart</strong>');
	            $("#messageToast .toast-body").html(data.message);
	            $("#messageToast").toast("show");
	            $(".cart-count").text(data.items);
            },
            error: function(data) {
            }
        });
	}

	// Params:
	// string elfo - element to fade out
	// string frm - id of form
	// string elfi - optional - element to fade in
	window.cancelForm = function(elfo, frm, elfi='') {
		$(elfo).fadeOut(300, function() {
			$(frm+" input[type=text]").val('');
			$(frm+" input[type=radio]:first").attr("checked",true);
			$(elfi).fadeIn(300);
		});
	}
	window.checkEmail = function(slug,email,el) {
		$.ajaxSetup({
		    headers: {
		        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		    }
		});
		if(email.length>8) {
	        $.ajax({
	            url: "/ajax/email/"+email+((slug!="")?"/"+slug:""),
	            type: 'POST',
	            dataType: 'html',
	            success: function(data) {
	                if(data=='true') {
		                el.parent().find(".alert").remove();
		                el.parent().addClass("has-error").append('<div class="alert-danger alert">The e-mail address has been taken.</div>');
	                } else {
		                el.parent().removeClass("has-error").addClass("has-success").find(".alert").remove();
	                }
	            }
	        });
	    }
	}
	/* Name: AjaxConfirmDialog
	   Purpose: Show confirmation dialog window with Yes/No buttons, submit ajax request
	   Params:
	   string msg - displayed message
	   string title - dialog window title
	   string url - url to submit ajax request to
	   string redirect - url for redirect, empty string if no redirect desired
	   mixed record - data parameter to send to ajax request url
	   bool reload - if page should reload/redirect
	   dom element el - dom element to hide and remove upon success of ajax request
	   bool showstatus - if page should show dom element with message upon success of ajax request
	   dom element statusel - element to show and fill with data variable on success of ajax request
	   string formmethod - method used to submit ajax request: POST, GET, DELETE, PATCH
	*/
	window.AjaxConfirmDialog = function(msg, title, url, redirect, record, reload=true, el=null, showstatus=false, statusel=null, formmethod='POST') {
		$.ajaxSetup({
		    headers: {
		        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		    }
		});

	    $("#dialog-confirm").html(msg);
	
		buttons = {
	            "Yes": function () {
	                $(this).dialog('close');
	                if(record!='') {
		                $.ajax({
			                url: url,
			                data: {record : record},
			                type: formmethod,
			                dataType: 'html',
			                success: function(data) {
				                if($redirect!='')
					                window.location = redirect;
			                }
		                });
	                } else {
		                $.ajax({
			                url: url,
			                type: formmethod,
			                dataType: 'html',
			                success: function(data) {
				                if(reload) {
					                window.location = redirect;
					            } else {
						            if(el!==null) {
							            el.fadeOut(300,function() { el.remove(); });
							        } else if(showstatus) {
							            $("#messageToast .toast-header .content").html('<i class="fa-solid fa-circle-info"></i>&nbsp;<strong class="me-auto">'+title+'</strong>');
							            $("#messageToast .toast-body").html(data);
							            $("#messageToast").toast("show");
							        }
					            }
			                }
		                });
	                }
	            },
	            "No": function () {
	                $(this).dialog('close');
	            }
	        };
	    showDialogOverlay('confirm',title,400,buttons);
	}
	
	window.showDialogOverlay = function(name,title,height,buttons,myWidth = wWidth) {
		if(wWidth < 700) {
			height = 0.9 * $(window).outerHeight();
		}
		$("#dialog-"+name).dialog({
	        resizable: false,
	        show: {
		        effect: "fade",
		        duration: 500
	        },
	        hide: {
		        effect: "fade",
		        duration: 300
	        },
	        open: function(event,ui) {
		        $(".ui-widget-overlay").addClass('custom-overlay');
		        $(".ui-dialog-titlebar-close", ui.dialog | ui).hide();
	        },
	        close: function(event,ui) {
		        $(".ui-widget-overlay").removeClass('custom-overlay');
	        },
	        modal: true,
	        title: title,
	        height: height,
	        width: myWidth,
	        buttons: buttons
	    });
	}

	window.SubmitConfirmDialog = function(msg, title, formEl) {
	    $("#dialog-confirm").html(msg);
	
		buttons = {
	            "Yes": function () {
	                $(this).dialog('close');
	            },
	            "No": function () {
	                $(this).dialog('close');
	                formEl.submit();
	            }
	        };
	    showDialogOverlay('confirm',title,400,buttons);
	}
	
	$(document).ready(function() {

		$('.paymentform').on("submit",function(e) {
			e.preventDefault();
			if($('#due').length) {
				$('.applied').val($('#due').val());
			}
			this.submit();
		});
		$( "input.radiobutton" ).checkboxradio({
	      icon: false
	    });
	    $( "input.datepicker" ).datepicker({
			changeMonth: true,
			changeYear: true,
			yearRange: "2022:2050",
			altFormat:"mm-dd-YYYY"
	    });
/*
	    var dtpval = $("input.datetimepicker").val();
	    $("input.datetimepicker").flatpickr({
		    dateFormat: "Y/m/d h:i K",
		    enableTime: true,
		    defaultDate: dtpval
	    });
*/
	    if($('input.datepicker').length) {
			$("input.datepicker").mask("90/90/0000");
	    }
	    if($('input.phone').length) {
			$("input.phone").mask("000-000-0000");
	    }
	    if($('input.creditcard').length) {
			$("input.creditcard").mask("0000 0000 0000 0009");
	    }
	    if($('input.money').length) {
		    $("input.money").mask("000000.00",{reverse:true});
	    }
	    if($('input.number').length) {
		    $("input.number").mask("00000000000000",{reverse:true});
	    }
/*
	    if($('.colorpicker').length) {
		    $(".colorpicker").mask("ZAAAAAA", {
			    translation: {
				    'Z' : {
					    pattern: /[#]/, optional: true
				    }
			    }
		    }).colorpicker({ colorFormat:'#HEX' });
	    }
*/
	    if($('.colorpicker').length) {
		    $(".colorpicker").colorpicker({ 
			    colorFormat:'RGB',
			    parts: 'popup',
			    showNoneButton: true,
			    alpha: false,
			    hsv:false,
			    limit:'websafe',
				altField: '.cp-alt-target',
				altProperties: 'background-color,color',
			});
	    }
        $(window).scroll(function() {
            wtop=$(window).scrollTop();
            if(wtop>2) {
                if(!$(".header").hasClass("sticky")) {
                    $(".header").addClass("sticky");
                }
            } else if(wtop<2) {
                if($(".header").hasClass("sticky")) {
                    $(".header").removeClass("sticky");
                }
            }
        });
        $(".show-wait").click(function() {
	       $(this).hide().next("div.wait").show(); 
        });
        $(".full-page").scroll(function() {
            wtop=$(".full-page").scrollTop();
            if(wtop>2) {
                if(!$(".header").hasClass("sticky")) {
                    $(".header").addClass("sticky");
                }
            } else if(wtop<2) {
                if($(".header").hasClass("sticky")) {
                    $(".header").removeClass("sticky");
                }
            }
        });
		$(".navbar-toggle").click(function() {
			$(".site-logo").stop().animate({
				"opacity":"0"
			});
			$(".main-navigation").stop().animate({
				"left":"0%"
			},400,function() { $(".main-navigation").addClass("open"); });
		});
		$(".navbar-close").click(function() {
			$(".site-logo").stop().animate({
				"opacity":"1"
			});
			$(".main-navigation").removeClass("open").stop().animate({
				"left":"-100%"
			},400);
		});
		
		$(".header,.footer,.page-container").click(function() {
			if($(".main-navigation").hasClass("open")) {
				$(".site-logo").stop().animate({
					"opacity":"1"
				});
				$(".main-navigation").removeClass("open").stop().animate({
					"left":"-100%"
				},400);
			}
		});
		$("#product_search_form").submit(function(e) {
			e.preventDefault();
			$.ajaxSetup({
			    headers: {
			        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			    }
			});
	        $.ajax({
	            url: "/ajax/product/list",
	            type: 'POST',
	            data: {partial:$("input#productpartial").val()},
	            dataType: 'json',
	            success: function(data) {
		            if('error' in data) {
			            console.log(data.error);
		            } else {
						$('.product-search-results').text('');
						$.each(data,function(i,item) {
							if($("#product_search_form input[name=action]").val()=="ticket") {
								$('.product-search-results').append('<div><a href="#" onclick="showAddProduct('+"'"+item.slug+"'"+','+$("#product_search_form input[name=ticket]").val()+')">'+item.sku+': '+item.name+'</a></div>');
							} else if($("#product_search_form input[name=action]").val()=="customer") {
								$('.product-search-results').append('<div><a href="#" onclick="showAddProduct('+"'"+item.slug+"'"+',0,'+"'"+$("#product_search_form input[name=customer]").val()+"'"+')">'+item.sku+': '+item.name+'</a></div>');
							} else if($("#product_search_form input[name=action]").val()=="creditmemo") {
								$('.product-search-results').append('<div><a href="#" onclick="showAddProduct('+"'"+item.slug+"'"+','+$("#product_search_form input[name=creditmemo]").val()+')">'+item.sku+': '+item.name+'</a></div>');
							}
						});
					}
	            }
	        });
	    });
		$("input[name=sameas]").on("click", function (e) {
		    var checkbox = $(this);
		    if (checkbox.is(":checked")) {
				if($('input[name=company').val()=="") {
					alert("Billing information must be entered first.");
					e.preventDefault();
					return false;
				} else {
					$('input[name=shipfirstname]').val($('input[name=firstname]').val());
					$('input[name=shiplastname]').val($('input[name=lastname]').val());
					$('input[name=shipcompany]').val($('input[name=company]').val());
					$('input[name=shipphone]').val($('input[name=phone]').val());
					$('input[name=shipphoneext]').val($('input[name=phoneext]').val());
					$('input[name=shipaddress]').val($('input[name=address]').val());
					$('input[name=shipaddress2]').val($('input[name=address2]').val());
					$('input[name=shipcity]').val($('input[name=city]').val());
					$('select[name=shipstate]').val($('select[name=state]').val());
					$('input[name=shipzip]').val($('input[name=zip]').val());
				}
		    }
		});
		
	});
    if($(".alert").length) {
		$(".alert").not(".nohide").fadeTo(8000, 500).slideUp(500, function(){
		    $(".alert").slideUp(500);
		});
    }
})(jQuery);
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
	  return new bootstrap.Popover(popoverTriggerEl)
	})
